import uiNotificationService from 'services/uiNotification.service';

import documentService from 'resources/document/document.service';

import { createTaskFilePath } from 'resources/document/generateStoragePath';

import { createDocument } from './createDocument';
import { deleteDocument } from './deleteDocument';

const removeDocuments = async (documents) => documents?.length
  && Promise.all(documents.map((document) => deleteDocument(document.id)));

const uploadDocumentsToTask = async ({
  fileData, taskId, taskCompanyId,
}) => {
  const oldDocuments = await documentService.getByTaskId(taskId);

  const oldFilesAmount = oldDocuments?.length;
  const newFilesAmount = fileData.files?.length;

  if (newFilesAmount === 0) {
    await removeDocuments(oldDocuments);
    return;
  }

  if (fileData.files?.every((file) => !!file.id) && oldFilesAmount === newFilesAmount) {
    return;
  }

  if (!fileData.files) {
    return;
  }

  await removeDocuments(oldDocuments);

  const newDocuments = await Promise.all(fileData.files.map((file) => (
    createDocument({
      file,
      bucket: 'tasks',
      filePath: createTaskFilePath({ id: taskId, fileName: file.name }),
      taskId,
      companyId: taskCompanyId,
      uploaderId: fileData.uploaderId,
    })
  )));

  uiNotificationService.showSuccess('Documents were uploaded');

  return newDocuments;
};

export {
  uploadDocumentsToTask,
};
